import { useQuery } from '@tanstack/react-query';
import { analyticsApi } from '../services/analytics-api.service';
import type { SearchQueryParams } from '../types/analytics.types';

export const searchKeys = {
  all: ['analytics', 'search'] as const,
  list: (params?: SearchQueryParams) =>
    [...searchKeys.all, 'list', params] as const,
};

export const useSearchData = (params?: SearchQueryParams, enabled = true) => {
  return useQuery({
    queryKey: searchKeys.list(params),
    queryFn: async () => {
      const response = await analyticsApi.getSearch(params);
      return response.data;
    },
    staleTime: 30 * 60 * 1000,
    enabled,
  });
};
